import { render } from "./ChangeTariffModal.vue?vue&type=template&id=04e196ae"
import script from "./ChangeTariffModal.vue?vue&type=script&lang=js"
export * from "./ChangeTariffModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__